import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FeedbackButton } from '@lab39/react-ui';
import { icons } from '../../data/icons';
import styles from '../../styles/modules/Layout.module.css';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className={styles.layout}>
      <Header />
      <main className={styles.main}>
        {children}
      </main>
      <Footer />
      <FeedbackButton
        apiEndpoint="https://api.lab39.org/v1/feedback"
        productName="PicCode"
        buttonIcon={icons.feedback}
        icons={{
          bug: icons.bug,
          feature: icons.feature,
          toolRequest: icons.toolRequest,
          feedback: icons.feedback,
          improvement: icons.improvement,
          attachment: icons.attachment,
          send: icons.send,
          info: icons.info,
          close: icons.close
        }}
      />
    </div>
  );
};

export default Layout;
